export default __webpack_public_path__ + "static/media/TrovityIcon.3a6d0b42.svg";